module.exports = [{
      plugin: require('/Users/jerome/code/ocular/website/node_modules/gatsby-plugin-styletron/gatsby-browser.js'),
      options: {"plugins":[]},
    },{
      plugin: require('/Users/jerome/code/ocular/website/node_modules/gatsby-remark-images/gatsby-browser.js'),
      options: {"plugins":[],"maxWidth":690},
    },{
      plugin: require('/Users/jerome/code/ocular/website/node_modules/gatsby-remark-autolink-headers/gatsby-browser.js'),
      options: {"plugins":[]},
    },{
      plugin: require('/Users/jerome/code/ocular/website/gatsby-browser.js'),
      options: {"plugins":[]},
    }]
